import {
  CURRENT_COMPANY_ID_HEADER_KEY,
  SILENT_REQUEST_HEADER_KEY,
} from "@hd/http-client/constants";
import httpClient from "@hd/http-client/http-client";
import { CommunicationChannelUseDto } from "@hd/types/dto/communication/communication-channel-use.dto";
import { CommunicationTypeEnum } from "@hd/types/dto/communication/communication-type.enum";
import { useQuery } from "@tanstack/react-query";

type QueryParams = {
  companyId: number | null;
  contactId: number | null;
  communicationType: CommunicationTypeEnum | null;
};

const apiUrl = `/communication/channel-use-for-contact`;

/** Radice della query key: invalidando questa si colpiscono tutti i contatti. */
export const channelUseForContactQueryRoot = [apiUrl];

const fetchData = async (
  params: QueryParams,
): Promise<CommunicationChannelUseDto> => {
  const result = await httpClient.get<CommunicationChannelUseDto>(
    import.meta.env.VITE_HD_API_URL + apiUrl,
    {
      params: {
        communicationType: params.communicationType,
        contactId: params.contactId,
      },
      headers: {
        [CURRENT_COMPANY_ID_HEADER_KEY]: params.companyId?.toString() || "",
        [SILENT_REQUEST_HEADER_KEY]: "true",
      },
    },
  );

  return result.data;
};

export const channelUseForContactQueryKey = (params: QueryParams) => [
  apiUrl,
  params.companyId,
  params.contactId,
  params.communicationType,
];

export const useChannelUseForContactQuery = (params: QueryParams) => {
  return useQuery({
    queryKey: channelUseForContactQueryKey(params),
    queryFn: () => fetchData(params),
    // per ora niente request in vista gruppo (companyId -1)
    enabled:
      !!params.companyId &&
      params.companyId > 0 &&
      !!params.contactId &&
      !!params.communicationType,
  });
};
